import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { likeRecordApi } from '../../api/likeRecord';

// 获取点赞记录列表
export const fetchLikeRecordList = createAsyncThunk(
  'likeRecord/fetchList',
  async (params, { rejectWithValue }) => {
    try {
      const response = await likeRecordApi.getLikeRecordList(params);
      // 期望后端返回 { code, message, data: { records, total, ... } }
      if (response && (response.code === 200 || response.success)) {
        return response.data;
      }
      return rejectWithValue(response?.message || '获取点赞记录失败');
    } catch (error) {
      return rejectWithValue(error?.message || '获取点赞记录失败');
    }
  }
);

// 获取点赞统计数据
export const fetchLikeStatistics = createAsyncThunk(
  'likeRecord/fetchStatistics',
  async (params, { rejectWithValue }) => {
    try {
      const response = await likeRecordApi.getLikeStatistics(params);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.message || '获取点赞统计失败');
    }
  }
);

// 获取内容互动数据
export const fetchContentInteractionData = createAsyncThunk(
  'likeRecord/fetchContentInteraction',
  async (params, { rejectWithValue }) => {
    try {
      const response = await likeRecordApi.getContentInteractionData(params);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.message || '获取内容互动数据失败');
    }
  }
);

// 识别违规点赞
export const identifyViolationLikes = createAsyncThunk(
  'likeRecord/identifyViolations',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await likeRecordApi.identifyViolationLikes(data);
      dispatch(fetchLikeStatistics());
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.message || '识别违规点赞失败');
    }
  }
);

// 处理违规点赞
export const processViolationLikes = createAsyncThunk(
  'likeRecord/processViolations',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await likeRecordApi.processViolationLikes(data);
      dispatch(fetchLikeRecordList());
      dispatch(fetchLikeStatistics());
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.message || '处理违规点赞失败');
    }
  }
);

// 点赞统计概览
export const fetchLikeStatsOverview = createAsyncThunk(
  'likeRecord/fetchStatsOverview',
  async (queryDTO, { rejectWithValue }) => {
    try {
      const response = await likeRecordApi.getLikeStatsOverview(queryDTO);
      if (response && (response.code === 200 || response.success)) {
        return response.data;
      }
      return rejectWithValue(response?.message || '获取点赞统计概览失败');
    } catch (error) {
      return rejectWithValue(error?.message || '获取点赞统计概览失败');
    }
  }
);

const likeRecordSlice = createSlice({
  name: 'likeRecord',
  initialState: {
    likeRecordList: [],
    likeTotal: 0,
    likeStatistics: null,
    contentInteractionData: null,
    likeStatsOverview: null,
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // 获取点赞记录列表
      .addCase(fetchLikeRecordList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLikeRecordList.fulfilled, (state, action) => {
        state.loading = false;
        // 兼容 data 为分页对象或直接数组
        const payload = action.payload || {};
        state.likeRecordList = Array.isArray(payload.records) ? payload.records : (Array.isArray(payload) ? payload : []);
        state.likeTotal = payload.total || 0;
      })
      .addCase(fetchLikeRecordList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      // 点赞统计数据
      .addCase(fetchLikeStatistics.fulfilled, (state, action) => {
        state.likeStatistics = action.payload;
      })
      
      // 内容互动数据
      .addCase(fetchContentInteractionData.fulfilled, (state, action) => {
        state.contentInteractionData = action.payload;
      })
      
      // 点赞统计概览
      .addCase(fetchLikeStatsOverview.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLikeStatsOverview.fulfilled, (state, action) => {
        state.loading = false;
        state.likeStatsOverview = action.payload || null;
      })
      .addCase(fetchLikeStatsOverview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default likeRecordSlice.reducer; 